import { FC, useState } from 'react';
import { Card, CardContent, Grid, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SCUIButton } from '../../../../atomic/atoms';
import { CommentCommand } from '../../../../services/command';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { CRR_D } from '../commentRejectReason.classes';

interface IProps {
    selectedRow?: any;
    onClose?: any;
    refresh?: any;
}
export const AddUpdateRejectReasonDrawer: FC<IProps> = ({ selectedRow, onClose, refresh }) => {
    const { t } = useTranslation();
    const [rejectReasonName, setRejectReasonName] = useState<string>(selectedRow.reasonForRejection);
    const handleAddRejectReason = () => {
        if (!rejectReasonName) {
            Swal.fire(t('general.error'), t('general.fillInput'), 'error');
            return;
        }
        let params = { reasonForRejection: rejectReasonName };
        if (rejectReasonName && rejectReasonName.trim().length > 0) {
            CommentCommand.CreateRejectPhotoReason(params).then((res) => {
                if (res) {
                    Swal.fire(t('general.success'), t('general.added'), 'success');
                    onClose();
                    refresh();
                }
            });
        }
        if (rejectReasonName && rejectReasonName.trim().length > 0) {
            CommentCommand.CreateRejectPhotoReason(params)
                .then((res) => {
                    if (res) {
                        Swal.fire(t('general.success'), t('general.added'), 'success');
                        onClose();
                        refresh();
                    }
                })
                .catch((error) => {
                    if (error?.data?.Key) {
                        Swal.fire(t('general.error'), `${error?.data?.Key}`, 'error');
                    } else {
                        Swal.fire(t('general.error'), t('comments.rejectReasonError'), 'error');
                    }
                    onClose();
                });
        }
    };
    const handleUpdateRejectReason = () => {
        if (!rejectReasonName) {
            Swal.fire(t('general.error'), t('general.fillInput'), 'error');
            return;
        }
        Swal.fire({
            title: t('general.updateConfirmationText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: t('general.update'),
            cancelButtonText: t('general.cancel'),
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                let req = { id: selectedRow.id, reasonForRejection: rejectReasonName };
                CommentCommand.UpdateRejectPhotoReason(req)
                    .then((res) => {
                        if (res) {
                            Swal.fire(t('general.success'), t('general.updated'), 'success');
                            onClose();
                            refresh();
                        }
                    })
                    .catch((error) => {
                        if (error?.data?.Key) {
                            Swal.fire(t('general.error'), `${error?.data?.Key}`, 'error');
                        } else {
                            Swal.fire(t('general.error'), t('comments.rejectReasonError'), 'error');
                        }
                        onClose();
                    });
            }
        });
    };
    return (
        <Card className={CRR_D.card}>
            <CardContent className={CRR_D.content}>
                <Grid className={CRR_D.layout} container style={{ margin: '1.5rem', gap: '1rem' }}>
                    <Grid
                        className={CRR_D.headerRow}
                        container
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                        }}
                    >
                        <Grid
                            container
                            sx={{
                                marginBottom: '3rem',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 10,
                                lg: 10,
                            }}
                        >
                            <h2>
                                {selectedRow?.id > 0 ? t('comments.editRejectReason') : t('comments.addRejectReason')}
                            </h2>
                        </Grid>
                        <Grid
                            sx={{ marginTop: '0.5rem' }}
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 2,
                                lg: 2,
                            }}
                        >
                            <CloseIcon
                                className={[CRR_D.closeIcon, 'cursorPointer'].join(' ')}
                                style={{ fontSize: '3rem' }}
                                onClick={onClose}
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        className={CRR_D.formGrid}
                        container
                        spacing={2}
                        size={{
                            xs: 12,
                        }}
                    >
                        <Grid
                            size={{
                                xs: 12,
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid
                                    sx={{ marginRight: '7rem' }}
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                    }}
                                >
                                    <TextField
                                        className={CRR_D.textFieldReason}
                                        fullWidth
                                        label={t('commentDetail.rejectReason')}
                                        type="text"
                                        value={rejectReasonName}
                                        defaultValue={selectedRow?.reasonForRejection}
                                        multiline
                                        onChange={(e: any) => setRejectReasonName(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        className={CRR_D.footerRow}
                        container
                        justifyContent="flex-end"
                        style={{ marginTop: '1rem', marginRight: '7rem' }}
                    >
                        <SCUIButton
                            className={CRR_D.saveButton}
                            onClick={() => {
                                if (selectedRow?.id) {
                                    handleUpdateRejectReason();
                                } else {
                                    handleAddRejectReason();
                                }
                            }}
                            type={'primary'}
                            sizeType={'fixed'}
                            size={'l'}
                            text={t('general.save')}
                        ></SCUIButton>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
